import { apiClient } from 'utils/requests.utils'

const BASE_URL = (username, isPowerSeller) => `/shop/${username}${isPowerSeller ? '/power_seller' : ''}/document`

export const createDocumentsApi = ({ GET }) => ({
  fetchItem: (type, data, isPowerSeller) => GET(`${BASE_URL(data.username, isPowerSeller)}/${type}`, data),
})

const api = createDocumentsApi(apiClient)
const fetchItem = api.fetchItem
export { fetchItem }
